import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Viele Jahre viel Geld ausgegeben. Nichts hat geholfen. Um so überraschter war ich, als schon nach 14 Tagen Besserung eintrat. Heute geht es unserer Lotta so gut wie nie.',
  author: 'Martina, Hundemama aus München'
}, {
  text: 'Mein Hund hat sich schnell an das Topping gewöhnt und nach ca. 1 Woche hat sich sein Stuhl verbessert. Ich bin super zufrieden und bestelle es auf jeden Fall erneut.',
  author: 'Sandra, Besitzerin eines Schäferhunds'
}, {
  text: 'Es hat so geholfen und gewirkt, wie sie es beschreiben. Nach zwei Wochen hatte unser Hund keine Beschwerden mehr.',
  author: 'Thomas aus Hamburg'
}, {
  text: 'Seit wir das Magen-Darm-Topping regelmäßig geben, geht es unserem Labrador viel viel besser. Macht weiter so!',
  author: 'Familie Weber & Charlie'
}];
export function Testimonials() {
  return <section className="w-full py-16 px-4 bg-cream-dark border-y border-brown-light/20" data-id="element-99">
      <div className="max-w-6xl mx-auto" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-101">
          <h2 className="font-handwriting text-4xl md:text-5xl text-forest mb-4" data-id="element-102">
            Nicht nur Bella geht es besser...
          </h2>
          <p className="font-serif text-lg text-brown-dark/70" data-id="element-103">
            Erfahrungen von anderen Hundebesitzern
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-104">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-brown-light/10" data-id="element-105">
              <div className="flex gap-1 mb-4" data-id="element-106">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-107" />)}
              </div>
              <p className="font-serif text-brown-dark/90 text-lg italic mb-6 leading-relaxed" data-id="element-108">
                "{review.text}"
              </p>
              <p className="font-serif font-semibold text-forest" data-id="element-109">
                – {review.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}